export default __webpack_public_path__ + "static/media/edit.09c4f367.svg";